import { useContext } from "react";
import { ClinicContext } from "../contexts/ClinicContext";

const useClinic = () => useContext(ClinicContext);

export default useClinic;
